import useCustomHook from '@/hooks/useCustomHook';

export default function useFlippableCard({ concept }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      cardOriginalSize: null,
      showFront: false,
    },
    actions: {
      onFlipUpdate: (latest) => {
        if (concept.flipped && latest.rotateY >= 90) {
          actions.setState({ showFront: true });
        } else if (!concept.flipped && latest.rotateY <= 90) {
          actions.setState({ showFront: false });
        }
      },
    },
  });

  return { state, actions };
}
